import React from 'react';
import PropTypes from 'prop-types';
import root from 'window-or-global';
import styles from './Disclaimer.pcss';
import {Message, Button} from 'epic-diesel-common';
import Cookies from 'universal-cookie';

/**
 * Used for dashboard confidential warning
 * Check client cookie to see if this component should pop up
 */
export default class Disclaimer extends React.Component {
    static propTypes = {
        theme: PropTypes.string,
        isLoading: PropTypes.bool,
        maxAge: PropTypes.number, // in seconds
        cookieName: PropTypes.string
    };

    static defaultProps = {
        theme: 'default',
        isLoading: false,
        maxAge: 60 * 60 * 24 * 7, // 7 days
        cookieName: '_AFFILIATE_DISCLAIMER'
    };

    state = {
        show: false
    };

    /**
     *  should disclaim if the cookie is not found
     */
    shouldDisclaim() {
        let shouldDisclaim = false; // default to false for sso rendering
        const {cookieName} = this.props;

        if (root.document) {
            const cookies = new Cookies(root.document.cookie);
            shouldDisclaim = !cookies.get(cookieName);
        }
        return shouldDisclaim;
    }

    setCookie() {
        const {maxAge, cookieName} = this.props;
        if (root.document) {
            const cookies = new Cookies(root.document.cookie);
            cookies.set(cookieName, true, {maxAge});
        }
    }

    confirm = () => {
        this.setCookie();
        this.setState({
            show: false
        });
    };

    componentDidMount() {
        if (this.shouldDisclaim()) {
            this.setState({
                // eslint-disable-line
                show: true
            });
        }
    }
    render() {
        const {show} = this.state;
        const {isLoading, theme} = this.props;
        const content = (
            <div className={`${styles.overlay} ${styles[theme]}`}>
                <div className={styles.container}>
                    <div className={styles.content}>
                        <p>
                            <Message code="epic.affiliate.earnings.disclaimer.greeting" />
                        </p>
                        <h1>
                            <Message code="epic.affiliate.earnings.disclaimer.important" />
                        </h1>
                        <p>
                            <Message code="epic.affiliate.earnings.disclaimer.decription1" />
                            <Message code="epic.affiliate.earnings.disclaimer.decription2" />
                        </p>
                        <div className={styles.button}>
                            <Button onClick={this.confirm} theme="dark">
                                <Message code="epic.affiliate.earnings.disclaimer.confirm" />
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );

        return !isLoading && show ? content : null;
    }
}
